<template>
  <a-modal
    title="账单明细"
    :visible.sync="visible"
    :width="1200"
    :footer="null"
    @cancel="cancel"
  >
    <div class="flex a-center flex-wrap">
      <!-- <div class="flex a-center mr-20 mb-20">
        <div>账单时间：</div>
        <div><a-range-picker v-model="time" class="w-190" @clear="time=null" /></div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">快递公司：</div>
        <div>
          <a-select v-model="params.shipperCode" class="w-140">
            <a-select-option :key="-1" :value="''">全部</a-select-option>
            <a-select-option v-for="(i,index) in companys" :key="index" :value="i.shipperCode">{{ i.shipperName }}</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">选择部门：</div>
        <div>
          <a-select v-model="params.departmentId" class="w-140">
            <a-select-option :key="-1" :value="''">全部</a-select-option>
            <a-select-option v-for="(i,index) in departmentList" :key="index" :value="i.departmentid">{{ i.departmentname }}</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="flex a-center mr-20 mb-20">
        <div class="">选择员工：</div>
        <div>
          <a-select v-model="params.originCustomerId" class="w-140">
            <a-select-option :key="-1" :value="''">全部</a-select-option>
            <a-select-option v-for="(i,index) in staffList" :key="index" :value="i.userid">{{ i.staffname }}</a-select-option>
          </a-select>
        </div>
      </div> -->
      <div class="flex a-center mr-20 mb-20">
        <!-- <a-button type="primary" class="mr-6" @click="getList(true)">查询</a-button> -->
        <a-button type="primary" @click="exp">导出excel</a-button>
      </div>
    </div>
    <a-table :columns="columns" :row-key="row=>row.kdnOrderCode" :data-source="list" :pagination="pagination" @change="handleTableChange">
      <span slot="orderState" slot-scope="row">
        {{ status[+row.orderState] }}
      </span>
      <span slot="status" slot-scope="row">
        {{ tStatus[row.status] }}
      </span>
    </a-table>
  </a-modal>
</template>
<script>
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    custBillCode: {
      type: String,
      default: ''
    }

  },
  data() {
    return {
    //   visible: true
      showForm: false,
      status: {
        1: '已收件',
        2: '在途中',
        3: '签收',
        4: '问题件'
      },
      tStatus: {
        0: '待交易',
        1: '交易成功',
        2: '交易失败'
      },
      time: null,
      list: [],
      companys: [],
      departmentList: [],
      staffList: [],
      columns: [
        { title: '下单时间', dataIndex: 'orderCreateTime', key: 'orderCreateTime' },
        { title: '快递公司', key: 'shipperName', dataIndex: 'shipperName' },
        { title: '快递单号', dataIndex: 'logisticCode', key: 'logisticCode' },
        { title: '寄件人', key: 'senderName', dataIndex: 'senderName' },
        { title: '物流状态', key: 'orderState', scopedSlots: { customRender: 'orderState' }},
        { title: '支付状态', key: 'status', scopedSlots: { customRender: 'status' }},
        { title: '运费金额', key: 'custFreight', dataIndex: 'custFreight' }
      ],
      params: {
        departmentId: '',
        originCustomerId: '',
        shipperCode: '',
        startTime: '',
        endTime: ''
      },
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      }
    }
  },
  computed: {

  },
  watch: {
    async visible(n) {
      if (n) {
        const res = await this.$http(this.$api.logisticsGetList)
        this.companys = res || []
        const list = await this.$http(this.$api.departmentGetDepartmentList)
        this.departmentList = list
        const staffList = await this.$http(this.$api.staffGetStaffList, {})
        this.staffList = staffList || []
        this.getList()
      }
    },
    time(n) {
      if (!n || !n.length) {
        this.params.startTime = ''
        this.params.endTime = ''
      } else {
        this.params.startTime = n[0].format('YYYY-MM-DD')
        this.params.endTime = n[1].format('YYYY-MM-DD')
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    //
    },
    async exp() {
      const p = {
        custBillCode: this.custBillCode,
        'pageIndex': this.pagination.current,
        'pageSize': this.pagination.pageSize
      }
      Object.assign(p, this.params)
      this.$down(this.$api.customerBillExportCustomerBillDetail, p)
    },
    async getList(isReset) {
      if (isReset) {
        this.pagination.current = 1
      }
      const p = {
        custBillCode: this.custBillCode,
        'pageIndex': this.pagination.current,
        'pageSize': this.pagination.pageSize
      }
      Object.assign(p, this.params)
      const res = await this.$http(this.$api.customerBillGetCustomerBillDetail, p)
      this.list = res.list || []
      this.pagination.total = res.totalSize
    },
    handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    }
  }
}
</script>
